module.exports = "/_next/static/images/jack-bg-pattern-859798aa811d297296dade168693eb9e.svg";